/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from 'react';
import { Box } from '@mui/material';
import { CustomTooltip } from './tooltip_component';
import networkMonotoring from '../../Assets/AlertIcon/networkingMonitoringLeftMenu.svg';
export const NetworkMonitoringLeftBarPath = (props) => {
  const { selectedIcon, activeItemStyle, iconStyle, handleIconClick, hideTooltip = false } = props;

  const iconContent = (
    <Box
      style={selectedIcon === 4 ? activeItemStyle : iconStyle}
      onClick={() => handleIconClick(4, 'Network Monitoring')}
    >
      {/* <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2ZM10 16C6.69 16 4 13.31 4 10C4 6.69 6.69 4 10 4C13.31 4 16 6.69 16 10C16 13.31 13.31 16 10 16Z"
          fill={selectedIcon === 4 ? '#BD1D23' : '#192126'}
        />
        <path
          d="M10 6C7.79 6 6 7.79 6 10C6 12.21 7.79 14 10 14C12.21 14 14 12.21 14 10C14 7.79 12.21 6 10 6ZM10 12C8.9 12 8 11.1 8 10C8 8.9 8.9 8 10 8C11.1 8 12 8.9 12 10C12 11.1 11.1 12 10 12Z"
          fill={selectedIcon === 4 ? '#BD1D23' : '#192126'}
        />
        <path
          d="M10 8C9.45 8 9 8.45 9 9C9 9.55 9.45 10 10 10C10.55 10 11 9.55 11 9C11 8.45 10.55 8 10 8Z"
          fill={selectedIcon === 4 ? '#BD1D23' : '#192126'}
        />
      </svg> */}
      <img src={networkMonotoring} />
    </Box>
  );

  return (
    <>
      {hideTooltip ? (
        iconContent
      ) : (
        <CustomTooltip title="Network Monitoring">{iconContent}</CustomTooltip>
      )}
    </>
  );
};
